// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3u-k_","errorLogs":"styles_errorLogs__2tK7g"};